<template>
  <div>
    <div class="grid-12 bg-green">
      <div class="container span-6 span-12-md mr-30 mx-0-md mr-0-above-md pr-30-above-md relative">
        <div class="px-0">
          <headline :title="'About us'" class="mb-0 mt-50 mt-30-sm hide show-md" />
          <h1 class="title mt-50 mb-50-md mt-30-sm pr-50 mb-100">
            Bulletin is the wholesale operating system connecting the next generation of brands and omni-channel
            retailers.
          </h1>
          <headline :title="'About us'" class="mb-0 hide-md headline--container__bottom" />
        </div>
      </div>
      <img
        :src="require('@/assets/img/bg-about-us-1.png')"
        alt="image-about-3"
        class="width-100 height-100 min-height-60 object-fit-cover span-6 span-12-md"
      />
    </div>

    <div class="page-wrapper container--medium max-width-800 mt-120 mt-50-sm px-42-md px-30-sm">
      <p class="cambon-regular-medium big mb-100 mb-50-sm text-justify text-left-sm text-left-sm font-size-16-sm">
        Meet your new favorite wholesale marketplace. Bulletin makes it easier than ever to discover extraordinary
        products, connect with best-in-class brands, and manage your entire wholesale business.
      </p>
      <img class="img-fullscreen mb-10" :src="require('@/assets/img/about/brightland.png')" alt="image-about-1" />

      <h1 class="title letter-spacing text-center my-60 mt-40-sm mb-30-sm font-size-33-sm line-height-38-sm">
        We understand retail.
      </h1>
      <p class="cambon-regular-medium big mb-20 text-justify text-left-sm font-size-16-sm">
        We used to run stores of our own. That’s why at Bulletin, we know that retail is personal. In fact, it isn't
        really about getting or placing orders. It's about relationships. It’s about a store owner buying tried-and-true
        favorites to delight their regular local customer: the mom around the corner, the couple up the block. It’s
        about a brand finding a new home offline, in the careful hands of a Store Manager who’s eager to sell their line
        and tell their story. It’s about retailers and brands meeting face-to-face, or the occasional phone call, where
        retailers can quickly share feedback, and brands can share updates. The best retail experiences - the stores we
        all love - are powered by an invisible web of small businesses championing each other and cheering each other
        on.
      </p>
      <p class="cambon-regular-medium big mb-80 mb-60-sm text-justify text-left-sm font-size-16-sm">
        As former retailers, we wanted to build a wholesale solution that helps stores with cash flow, and a marketplace
        experience that helps them find the very best brands - the ones customers will notice, fall in love with, and
        keep coming back for.
        <b class="bold"
          >That's why we offer net-60 terms to qualified retailers, vet every brand for quality and reliability, and
          offer white-glove customer service to make sure every single wholesale order you place, or receive, is a
          success.</b
        >
      </p>
      <img class="img-fullscreen mb-10" :src="require('@/assets/img/about/modern_citizen.png')" alt="image-about-1" />

      <h1 class="title letter-spacing text-center my-60 mt-40-sm mb-30-sm font-size-33-sm line-height-38-sm">
        We believe in brand and retailer relationships, not just transactions.
      </h1>
      <p class="cambon-regular-medium big mb-80 mb-60-sm text-justify text-left-sm font-size-16-sm">
        At Bulletin, we believe in making wholesale human again. Frankly, this isn’t that revolutionary. It’s just what
        you deserve. If we’ve learned anything from our brands and retailers, it’s that you’re resilient as hell. You’re
        scrappy. You’re passionate. You’re creative, hard-working, unbreakable and unique. You’re a remarkable creator
        making beautiful products, or a masterful curator running a compelling, money-making storefront. You depend on
        each other to sell and grow, and you’re both looking for partnership. You’re both looking for connection,
        feedback and support. Put simply, we want to facilitate the community and connection you’ve been asking for.
      </p>

      <img class="img-fullscreen mb-10" :src="require('@/assets/img/about/golde.png')" alt="image-about-2" />
      <h1 class="title letter-spacing text-center my-60 mt-40-sm mb-30-sm font-size-33-sm line-height-38-sm">
        We think wholesale should be fun and hassle-free.
      </h1>
      <p class="cambon-regular-medium big mb-60 text-justify text-left-sm font-size-16-sm">
        Bulletin’s platform is simple and straightforward for brands and retailers alike. Our slick order management
        tools, shipping guidelines, invoicing system, Direct Messaging feature and more make online wholesale a breeze.
        That way, brands can simply focus on making knockout products and growing their wholesale business, while
        retailers can focus on fine-tuning their assortments, inventory planning, and engaging customers. Net-15 payout
        terms mean brands never have to worry about getting paid on-time, and net-60 payment terms for retailers means
        store owners can make profits on retail sales before paying a single wholesale invoice. We’re built to help you
        succeed - and sell! That’s what Bulletin is all about.
      </p>
    </div>
    <div class="full-size-layout pt-30-sm pb-30-sm background-grey">
      <div class="container">
        <headline :title="'Press'" class="mb-30-sm" />

        <div class="grid-12 grid-column-gap-28 grid-column-gap-0-sm">
          <div class="span-4 span-12-md mb-20">
            "[Bulletin is] a beautifully curated wholesale marketplace featuring the hottest brands in clothing,
            handbags, beauty, jewelry, lifestyle and more. [They make] it easier than ever before for retailers to
            discover and stock quality products, and for digitally native brands to gain essential real-world exposure.”
            <h5 class="font-size-12 uppercase">– Entrepreneur</h5>
          </div>
          <div class="span-4 span-12-md mb-20">
            “Bulletin makes launching & scaling a wholesale business affordable and seamless… [providing] retailers with
            a list of curated wholesale brands that have been vetted through quality checks, customer reviews,
            packaging, and more."
            <h5 class="font-size-12 uppercase">– AdWeek</h5>
          </div>
          <div class="span-4 span-12-md mb-20">
            “[Bulletin’s] big focus: creating a curated buying experience for their retailers rather than an ‘everything
            to everyone’ experience… For brands who are a bit more thoughtful about where they want to distribute their
            products and who their retailers should be, Bulletin is a better bet.”
            <h5 class="font-size-12 uppercase">– Wholesale in a box</h5>
          </div>
        </div>

        <div class="page-wrapper py-0 mt-20">
          <div class="grid-wrapper grid-12 image-wrapper logoes-wrapper text-center">
            <div v-for="item of press" :key="item.link" :class="item.class" class="mt-30">
              <a target="_blank" :href="item.link">
                <img class="pointer" style="width: 280px; height: 122.5px" :src="item.image" alt="logo-wsj" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isVisitor" class="grid-12">
      <img
        :src="require('@/assets/img/bg-jewels-lg.jpg')"
        alt="image-about-3"
        class="width-100 height-100 min-height-60 object-fit-cover span-6 span-12-sm"
      />
      <div class="span-6 span-12-sm bg-green">
        <div class="container text-center py-180 pt-50-sm pb-80-sm">
          <h1 class="mb-40 mb-20-sm font-size-20-sm">
            IT'S NICE TO<br />
            MEET YOU
          </h1>
          <p class="line-height-26 mb-60 mb-50-sm font-size-20 font-size-14-sm line-height-16-sm">
            Bulletin is a curated wholesale marketplace <br class="hide-md" />filled with the most coveted brands.<br
              class="hide-md"
            />
            Welcome to the retail revolution.
          </p>
          <bulletin-button
            variant="primary"
            class="width-280 width-100-sm mb-30 mb-15-sm"
            :to="{ path: '/wholesale-retail/buyer' }"
          >
            Sign up a retailer
          </bulletin-button>
          <br />
          <bulletin-button variant="primary" class="width-280 width-100-sm" :to="{ path: '/wholesale-retail/brand' }">
            Apply as a brand
          </bulletin-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nytImage from '@/assets/img/companies-logo/nyt.png'
import tcImage from '@/assets/img/companies-logo/tc.png'
import wholesaleInABoxImage from '@/assets/img/companies-logo/wholesaleinabox.png'
import entrepreneur from '@/assets/img/companies-logo/entrepreneur.png'
import adweekImage from '@/assets/img/companies-logo/adweek.png'
import glossyImage from '@/assets/img/companies-logo/glossy.png'
import bofImage from '@/assets/img/companies-logo/bof.png'

export default {
  data() {
    return {
      press: [
        {
          image: nytImage,
          link: 'https://www.nytimes.com/2017/11/15/style/bulletin-broads-feminist-flea-market.html',
          class: 'span-3 span-12-md'
        },
        {
          image: tcImage,
          link: 'https://techcrunch.com/2017/05/24/bulletin-seed-funding/',
          class: 'span-3 span-12-md'
        },
        {
          image: wholesaleInABoxImage,
          link: 'https://www.wholesaleinabox.com/growingsteadyblog/bulletin-wholesale-reviews-and-maker-tips',
          class: 'span-3 span-12-md'
        },
        {
          image:entrepreneur,
          link: 'https://www.entrepreneur.com/article/377263',
          class: 'span-3 span-12-md'
        },
        {
          image: adweekImage,
          link: 'https://www.adweek.com/performance-marketing/the-growth-of-online-marketplaces-in-2021-and-beyond/',
          class: 'span-4 span-12-md'
        },
        {
          image: glossyImage,
          link: 'https://www.glossy.co/fashion/online-marketplaces-are-rushing-to-the-aid-of-their-small-business-partners/',
          class: 'span-4 span-12-md'
        },
        {
          image: bofImage,
          link: 'https://www.businessoffashion.com/articles/retail/local-retail-pandemic-brick-and-mortar',
          class: 'span-4 span-12-md'
        }
      ]
    }
  },
  computed: {
    activeMembers() {
      return this.members.filter((m) => m.alumni !== true)
    },
    isVisitor() {
      return this.$session.getRole() === 'VISITOR'
    }
  }
}
</script>

<style lang="scss">
.about-team--image {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 50%;
}

@import '../../assets/sass/base/vars.scss';
@import '../../assets/sass/base/helpers.scss';

p.regular--big {
  font-size: 25px !important;
}

div.grid-wrapper.grid-wrapper--col__2 {
  div.image {
    position: relative;

    > img {
      @extend %absolute-image;
      @include respond-to('xsmall') {
        object-fit: none;
      }

      width: calc(100% + 0.15%); //gap issue

      &.image-right {
        //gap issue
        left: 0.15%;

        @include respond-to('medium') {
          left: 0;
        }
      }
    }

    @include respond-to('medium') {
      height: 400px;
    }
  }
}

div.grid-wrapper.image-wrapper {
  div {
    display: flex;
    justify-content: center;

    > a {
      img {
        margin: 0 auto;
        display: block;
        height: 90px;
        // width: 120px;

        // shrink images when on small
        @include respond-to('small') {
          width: 50%;
        }
      }
    }
  }
}

.page-wrapper {
  &.extended-padding {
    @include respond-to('medium') {
      padding: 50px 0;
    }

    padding-top: 200px;
    padding-bottom: 140px;
  }

  div.container {
    h1 {
      margin-bottom: 65px;

      &.margin-bottom-140 {
        margin-bottom: 140px;

        @include respond-to('medium') {
          margin-bottom: 20px;
        }
      }

      @include respond-to('medium') {
        margin-bottom: 20px;
        padding: 0;
      }

      @include respond-to('large') {
        font-size: 30px;
      }
    }

    > p {
      line-height: 30px;
    }

    > button.button.button-transparent.width-280 {
      width: 50%;
    }
  }
}

.full-size-layout {
  padding: 45px 0 130px 0;

  @include respond-to('small') {
    padding: 45px 0 80px 0;
  }

  p {
    text-align: center;
  }

  .banner {
    margin-bottom: 35px;
  }
}
</style>
